<template>
    <v-card class="mx-auto full-width-card" variant="flat" title="Print Label">
        <v-container fluid class="full-width-container">
            <v-card class="mx-auto full-width-container" variant="flat">
                <div class="text-overline mb-1">Type</div>
                <v-form>
                    <v-checkbox
                        label="Approval"
                        v-model="labelType"
                    ></v-checkbox>
                    <v-select
                        v-if="setBuilding"
                        v-model="setBldg"
                        :items="buildings"
                        small="true"
                        label="Select Your Building"
                        @update:modelValue="disabled = false"
                    ></v-select>
                    <div class="text-overline mb-1">Copies</div>
                    <v-text-field
                        :disabled="disabled ? true : false"
                        variant="outlined"
                        class="mx-auto"
                        type="number"
                        min="1"
                        v-model="copiesValue"
                        @update:modalValue="updateCount"
                    >
                    </v-text-field>
                    <v-select
                        :disabled="disabled ? true : false"
                        density="compact"
                        v-model="department"
                        :items="buildingFK ? getDeptSelects : deptOptions"
                        :error-messages="errorMsg"
                        label="Department"
                        variant="outlined"
                        color="primary"
                        style="margin-top: 10px"
                        @update:menu="clearError"
                    >
                    </v-select>
                </v-form>
            </v-card>
            <v-row style="margin-top: 40px">
                <v-col>
                    <v-btn
                        color="error"
                        class="custom-large-btn"
                        variant="elevated"
                        @click="closePrintLabel"
                    >
                        <span class="button-text">Close</span>
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn
                        :loading="loading"
                        :disabled="disabled ? true : false"
                        color="primary"
                        class="custom-large-btn action-buttons"
                        variant="elevated"
                        @click="handlePrint"
                    >
                        <span class="button-text">Print</span>
                        <template v-slot:loader>
                            <v-progress-circular
                                indeterminate
                            ></v-progress-circular>
                        </template>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import axios from "axios";

export default {
    name: "PrintLabelUA",
    emits: ["closePrintLabel"],
    props: {
        multiLabel: {
            type: Array,
            default: null,
        },
        material: {
            type: Object,
            default: null,
        },
        printMaster: {
            type: Boolean,
            default: false,
        },
        masterInfo: {
            type: Object,
            default: null,
        },
        printAll: {
            type: Boolean,
            default: false,
        },
        allPrintInfo: {
            type: Object,
            default: null,
        },
        printPartOnly: {
            type: [Array, String],
            default: null,
        },
        isHistory: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            disabled: false,
            copiesValue: 1,
            department: null,
            deptOptions: [], // ARRAY OF DEPT OPTIONS WHEN USER HAS NO BUILDING
            labelType: false,
            buildingFK: null,
            errorMsg: [],
            setBuilding: false,
            setBldg: null,
            buildings: [],
            buildingDepts: {
                20: [
                    { value: "ASM", title: "Assembly" },
                    { value: "CNC", title: "CNC" },
                    { value: "NS", title: "New Stores" },
                    { value: "SIL", title: "Silkscreen" },
                    { value: "LOG", title: "Logistics Office" },
                    { value: "RCV", title: "Receiving Area" },
                ],
                75: [
                    { value: "ASM", title: "Assembly" },
                    { value: "CNC", title: "CNC" },
                    { value: "DIGITAL", title: "DIGITAL" },
                    { value: "CNCROBOTS", title: "CNC ROBOTS" },
                    { value: "LOG", title: "Warehouse/Logistics" },
                ],
                70: [
                    { value: "ASM", title: "Assembly" },
                    { value: "CNC", title: "CNC" },
                    { value: "DIGITAL", title: "DIGITAL" },
                    { value: "SIL", title: "Silkscreen" },
                    { value: "VACF", title: "VacForm" },
                    { value: "LOG", title: "Warehouse/Logistics" },
                ],
                85: [
                    { value: "SAW", title: "Saw" },
                    { value: "SIL", title: "Silkscreen" },
                    { value: "LOG", title: "Warehouse/Logistics" },
                ],
                100: [{ value: "LOG", title: "Warehouse/Logistics" }],
                DFR: [{ value: "MATLABS", title: "MAT LABS" }],
            },
        };
    },
    computed: {
        getDeptSelects() {
            if (this.buildingFK) {
                const selectedBuilding = this.buildingFK
                    ? this.buildingFK
                    : this.setBldg; // Replace with the desired building value
                const buildingDeptItems = this.buildingDepts[selectedBuilding];

                return buildingDeptItems.map((item) => {
                    return {
                        value: item.value,
                        title: item.title,
                    };
                });
            }
        },
    },
    watch: {
        setBldg(newVal) {
            const selectedBuilding = newVal; // Replace with the desired building value
            const buildingDeptItems = this.buildingDepts[selectedBuilding];

            this.deptOptions = buildingDeptItems.map((item) => {
                return {
                    value: item.value,
                    title: item.title,
                };
            });
        },
    },
    mounted() {
        // console.log(this.buildingDepts[this.self.buildingFK]);
        // console.log("props::", {
        //     material: this.material,
        //     printMaster: this.printMaster,
        //     masterInfo: this.masterInfo,
        //     printAll: this.printAll,
        //     allPrintInfo: this.allPrintInfo,
        //     isHistory: this.isHistory,
        //     printPO: this.printPOMlt,
        // });
        if (!this.buildingFK) {
            // alert(
            //     "You Do Not Have A Building Assigned To You... Please Contact HR To Assign A Building When Available\nPress Ok To Continue"
            // );
            this.setBuilding = true;
            this.disabled = true;
            this.fetchBuildings();
        }
        if (this.printPOMlt) {
            if (this.printPOMlt.length === 1) {
                this.printPartOnly = this.printPOMlt[0];
            }
        }
    },
    methods: {
        closePrintLabel() {
            this.$emit("closePrintLabel");
        },
        updateCount() {
            this.copiesValue = parseInt(this.copiesValue, 10) || 1;
        },
        async handlePrint() {
            if (!this.department) {
                this.errorMsg.push("Please Select A Department");
            } else {
                this.loading = true;
                if (this.multiLabel && this.multiLabel.length) {
                    try {
                        const type = this.labelType ? "Approval" : "Complete";
                        this.multiLabel.forEach((ele) => {
                            axios
                                .post(
                                    route(
                                        "legacy-api-assembly-printOpCompleteLabel",
                                        {
                                            TabletID: "Dashboard",
                                            Department: this.department,
                                            Building: this.buildingFK
                                                ? this.buildingFK
                                                : this.setBldg,
                                            JobNum: ele.JobNum,
                                            AsmSeq: ele.AsmSeq,
                                            OprSeq: ele.OprSeq,
                                            Part: ele.AssemblyPart,
                                            Description:
                                                ele.AssemblyDescription,
                                            // MtlPart:
                                            //     this.multiLabel[0].PartNum.length >
                                            //     1
                                            //         ? this.multiLabel[0].PartNum[0]
                                            //         : "",
                                            // MtlDesc:
                                            //     this.multiLabel[0].MtlDescription
                                            //         .length > 1
                                            //         ? this.multiLabel[0]
                                            //               .MtlDescription[0]
                                            //         : this.multiLabel
                                            //               .MtlDescription,
                                            MtlPart: ele.MtlPart,
                                            MtlDescription: ele.MtlDescription,
                                            ScheduleBuilding: "",
                                            Type: type,
                                            Preview: 0,
                                            Copies: this.copiesValue,
                                            PreviewOnly: 0,
                                        }
                                    )
                                )
                                .then((res) => {
                                    if (res.data.Status === 0) {
                                        alert("Error, Please Try Again");
                                    } else {
                                        //
                                    }
                                });
                        });

                        alert("Printing Now....");
                        this.closePrintLabel();
                    } catch (err) {
                        console.log(err);
                    }
                }
                if (
                    this.material &&
                    !this.printAll &&
                    !this.printMaster &&
                    !this.printPartOnly
                ) {
                    const from = parseInt(this.material.FromBuilding);
                    const to = parseInt(this.material.ToBuilding);
                    if (from !== to) {
                        this.printTransfer(from, to);
                    } else {
                        this.printLabel();
                    }
                } else if (
                    this.printAll &&
                    !this.material &&
                    !this.printMaster &&
                    !this.printPartOnly
                ) {
                    this.printLabel();
                } else if (
                    this.printMaster &&
                    !this.material &&
                    !this.printAll &&
                    !this.printPartOnly
                ) {
                    this.printMasterLabel();
                } else if (
                    this.printPartOnly &&
                    !this.material &&
                    !this.printAll &&
                    !this.printMaster
                ) {
                    this.printPartLabel();
                }
            }
        },
        async printLabel() {
            const type = this.labelType ? "Approval" : "Complete";
            const history = this.isHistory ? 1 : 0;
            if (this.material && !this.printAll) {
                try {
                    await axios
                        .post(
                            route("legacy-api.logistics-printIssueLabel", {
                                id: this.material.SysRowID,
                                copies: this.copiesValue,
                                building: this.buildingFK
                                    ? this.buildingFK
                                    : this.setBldg,
                                type: type,
                                department: this.department,
                                preview: 0,
                                history: history,
                            })
                        )
                        .then((res) => {
                            if (res.data.Status === 0) {
                                alert("Error, Please Try Again");
                            } else {
                                alert("Printing Now....");
                                this.closePrintLabel();
                            }
                        });
                } catch (err) {
                    console.log(err);
                }
            } else if (this.printAll && !this.material) {
                const sysRowIDs = this.allPrintInfo.map((obj) => obj.SysRowID);
                try {
                    await axios
                        .post(
                            route("legacy-api.logistics-printIssueLabel", {
                                id: sysRowIDs,
                                copies: this.copiesValue,
                                building: this.buildingFK
                                    ? this.buildingFK
                                    : this.setBldg,
                                type: type,
                                department: this.department,
                                preview: 0,
                                history: 0,
                            })
                        )
                        .then((res) => {
                            if (res.data.Status === 0) {
                                alert("Error, Please Try Again");
                            } else {
                                console.log("Printing All Issue Labels");
                                alert("Printing Now....");
                                this.closePrintLabel();
                            }
                        });
                } catch (err) {
                    console.log(err);
                }
            }
            this.loading = false;
        },
        async printMasterLabel() {
            const type = this.labelType ? "Approval" : "Complete";
            try {
                await axios
                    .post(
                        route("legacy-api.logistics-printMasterLabel", {
                            copies: this.copiesValue,
                            part: this.masterInfo.PartNum,
                            building: this.buildingFK
                                ? this.buildingFK
                                : this.setBldg,
                            department: this.department,
                            preview: 0,
                            history: 0,
                            type: type,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status === 0) {
                            alert("Error, Please Try Again");
                        } else {
                            console.log("Printing Master Label");
                            alert("Printing Now....");
                            this.closePrintLabel();
                        }
                    });
            } catch (err) {
                console.log(err);
            }
            this.loading = false;
        },
        async printTransfer(from, to) {
            const type = this.labelType ? "Approval" : "Complete";
            try {
                await axios
                    .post(
                        route("legacy-api.logistics-printTransferLabel", {
                            copies: this.copiesValue,
                            part: this.material.PartNum,
                            building: this.buildingFK
                                ? this.buildingFK
                                : this.setBldg,
                            type: type,
                            department: this.department,
                            to: to,
                            from: from,
                            preview: 0,
                            history: 0,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status === 0) {
                            alert("Error, Please Try Again");
                        } else {
                            console.log("Printing Transfer Label");
                            alert("Printing Now....");
                            this.closePrintLabel();
                        }
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async printPartLabel() {
            const type = this.labelType ? "Approval" : "Complete";
            try {
                await axios
                    .post(
                        route("legacy-api.logistics-printPartOnly", {
                            copies: this.copiesValue,
                            part: this.printPOMlt
                                ? this.printPOMlt
                                : this.printPartOnly,
                            building: this.buildingFK
                                ? this.buildingFK
                                : this.setBldg,
                            type: type,
                            department: this.department,
                            preview: 0,
                            history: 0,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status === 0) {
                            alert("Error, Please Try Again");
                        } else {
                            console.log("Printing Part Only Label");
                            alert("Printing Now....");
                            this.closePrintLabel();
                        }
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async fetchBuildings() {
            this.buildings = [];
            try {
                await axios
                    .get(
                        route("legacy-api.fetch-warehouse", {
                            fetchWarehouseOnly: 1,
                        })
                    )
                    .then((res) => {
                        this.sortDropdown(res.data); //SORTS THE GARBAGE/COUNT VIEW DROPDOWN VALUES
                    });
            } catch (err) {
                console.log(err);
            }
        },
        sortDropdown(array) {
            //SORTS BUILDING DROPDOWN TO BE IN NUMERICAL ORDER
            array.sort(function (a, b) {
                var nameA = parseInt(a);
                var nameB = parseInt(b);
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            this.buildings = array;
        },
        clearError() {
            this.errorMsg = [];
        },
    },
};
</script>
<style scoped lang="css">
.grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
}

.grid-item {
    padding: 1px;
    text-align: center;
}

.action-buttons {
    float: right;
}

.full-width-container {
    width: 100%;
}

.full-width-card {
    width: 80% !important;
}

.custom-large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    padding: 60px 60px;
    width: 40%;
}

.button-text {
    display: inline-block;
}
</style>
